import TeamCreate from "components/Cards/TeamCreate";
 import React from "react";
 
 
 export default function CreateTeam() {
   return (
     <>
       <div className="flex flex-wrap mt-4">
         <div className="w-full mb-12 px-4">
           <TeamCreate />
         </div>
       </div>
     </>
   );
 }
 